export enum UsersAcceptInvitationTypes {
    DunsNumber = 'duns_number',
    AlternateEmails = 'alternate_emails',
    CompanyName = 'company_name',
    Email = 'email',
    AllowAlertEmails = "allow_alert_emails"
}